import { SERVICES_URL, handleError } from "api/helper";
import { post } from "api/http";
import { MediaService } from "@adfenix/types";
import { useQuery } from "@tanstack/react-query";

const baseAuthUrlV1 = "media/auth/v1";

export const addUploadedImage = (
  request: MediaService.CreateUploadedImageReferenceRequest
): Promise<void> =>
  post(`${SERVICES_URL}/${baseAuthUrlV1}/image/reference`, request).catch(
    handleError
  );

export const getUploadedImage = (
  image: MediaService.ImageUploadRequest
): Promise<MediaService.UploadedImageModel> =>
  post(
    `${SERVICES_URL}/${baseAuthUrlV1}/image/get-uploaded-image`,
    image
  ).catch(handleError);

export const useUploadedImage = (
  src: string | undefined,
  maintainFileType: boolean
) =>
  useQuery(
    ["uploaded-image", src],
    () =>
      getUploadedImage({
        url: src!,
        maintainFileType
      }),
    {
      enabled: !!src
    }
  );
